import { Stack } from '@mui/material';
import { Error, CheckCircle, Info } from '@mui/icons-material';

import AgTypography from '../../stories/Styles/AgTypography';
import { AgColor } from '../../stories/Styles/AgColor';

import * as S from './styled';

const AgAlert = ({ type, message }: { type: 'error' | 'success' | 'info' | 'customError', message: string }) => {
  const icon = (type === 'error' || type === 'customError')
    ? <Error fontSize='inherit' color='error' />
    : type === 'success'
      ? <CheckCircle fontSize='inherit' color='success' />
      : type === 'info'
        ? <Info fontSize='inherit' color='info' />
        : null;

  return (
    <S.Notification className={type}>
      <Stack direction='row' gap={1} alignItems='center'>
        {icon}
        <AgTypography
          contentStyle='AP.H5.Bold'
          message={message}
          style={{
            color: type === 'error' || type === 'customError'
              ? AgColor.errorHighlight
              : type === 'success'
                ? AgColor.greenMain
                : type === 'info'
                  ? AgColor.blueMain
                  : AgColor.grey6
          }}
        />
      </Stack>
    </S.Notification>
  );
};

export default AgAlert;